<template>
	<v-row justify="center">
		<v-dialog v-model="dialog" persistent max-width="800" v-if="dialog" scrollable>
			<v-card>
				<v-card-title class="pb-4 font-size-14">Destinasi Pengiriman</v-card-title>
				<v-card-text class="py-0">
					<v-row>
						<v-col cols="12" class="pt-0">
							<!-- {{google.maps}} -->
							<div class="rounded overflow-hidden">
								<GmapMap :center="mapCenter" :zoom="12"  style="width: 100%; height: 220px; border-radius: 8px">
									<!-- <GmapMarker v-for="(m, index) in markers" :key="index" :position="m.position" :clickable="true" :draggable="true" @click="center=m.position">
									</GmapMarker> -->
									<!-- <GmapMarker :position="google && new google.maps.LatLng(-7.782517, 110.367027)" /> -->
								</GmapMap>
								<!-- <div id="map"></div> -->
								<!-- <Maps></Maps> -->
							</div>
						</v-col>
					</v-row>
					<v-row>
						<v-col cols="3">
							<v-card outlined class="px-2 py-3" height="110">
								<div class="text-center">
									<div class="font-size-10 font-weight-bold grey--text text--darken-2 title-destination-detail">Jumlah Muatan</div>
									<div class="pt-3 font-size-20 font-weight-bold primary--text text--lighten-1">150</div>
								</div>
							</v-card>
						</v-col>
						<v-col cols="3">
							<v-card outlined class="pa-3" height="110">
								<div class="text-center">
									<div class="font-size-10 font-weight-bold grey--text text--darken-2 title-destination-detail">Berat Muatan</div>
									<div class="pt-3 font-size-20 font-weight-bold primary--text text--lighten-1">750 Kg</div>
								</div>
							</v-card>
						</v-col>
						<v-col cols="3">
							<v-card outlined class="pa-3" height="110">
								<div class="text-center">
									<div class="font-size-10 font-weight-bold grey--text text--darken-2 title-destination-detail">Estimasi Jarak WH</div>
									<div class="pt-3 font-size-20 font-weight-bold primary--text text--lighten-1">5 Km</div>
								</div>
							</v-card>
						</v-col>
						<v-col cols="3">
							<v-card outlined class="pa-3" height="110">
								<div class="text-center">
									<div class="font-size-10 font-weight-bold grey--text text--darken-2 title-destination-detail">Estimasi Jarak Destinasi Sebelumnya</div>
									<div class="pt-3 font-size-20 font-weight-bold primary--text text--lighten-1">100 Km</div>
								</div>
							</v-card>
						</v-col>
					</v-row>
					<v-row>
						<v-col cols="6" class="pb-0">
							<v-text-field outlined dense placeholder="Nomor Pengiriman" color="primary lighten-1"></v-text-field>
						</v-col>
						<v-col cols="6" class="pb-0">
							<v-autocomplete outlined dense placeholder="Pilih Provinsi" no-data-text="Tidak ada data" color="primary lighten-1"></v-autocomplete>
						</v-col>
						<v-col cols="6" class="py-0">
							<v-text-field outlined dense placeholder="Nomor Referensi" color="primary lighten-1"></v-text-field>
						</v-col>
						<v-col cols="6" class="py-0">
							<v-autocomplete outlined dense placeholder="Pilih Kabupaten" no-data-text="Tidak ada data" color="primary lighten-1"></v-autocomplete>
						</v-col>
						<v-col cols="6" class="py-0">
							<v-text-field outlined dense placeholder="Nama Penerima" color="primary lighten-1"></v-text-field>
						</v-col>
						<v-col cols="6" class="py-0">
							<v-autocomplete outlined dense placeholder="Pilih Kecamatan" no-data-text="Tidak ada data" color="primary lighten-1"></v-autocomplete>
						</v-col>
						<v-col cols="6" class="py-0">
							<v-text-field outlined dense placeholder="Kode Pos" color="primary lighten-1"></v-text-field>
						</v-col>
						<v-col cols="6" class="py-0">
							<v-textarea outlined placeholder="Alamat" color="primary lighten-1" no-resize height="80"></v-textarea>
						</v-col>
					</v-row>
					<v-row>
						<div class="px-3 pt-3">
							<v-btn large depressed color="primary lighten-1">
								<div class="d-flex">
									<v-icon small>mdi-plus-circle</v-icon>
									<div class="pl-2 font-weight-bold text-capitalize">Tambah Muatan</div>
								</div>
							</v-btn>
						</div>
						<v-col cols="12">
							<v-card outlined>
								<v-simple-table class="white-row">
									<template v-slot:default>
										<thead class="v-data-table-header">
											<tr>
												<th width="45%" class="text-left">Nama Produk</th>
												<th width="15%" class="text-left">Jumlah</th>
												<th width="10%" class="text-left">Berat</th>
												<th width="15%" class="text-left">Total Berat</th>
												<th width="10%" class="text-left">Aksi</th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="i in 2" :key="i">
												<td>
													<div class="py-2">
														<v-autocomplete outlined dense placeholder="Pilih Produk" hide-details="auto" no-data-text="Tidak ada data" color="primary lighten-1" background-color="white"></v-autocomplete>
													</div>
												</td>
												<td>
													<div class="py-2">
														<v-text-field outlined dense color="primary lighten-1" hide-details="auto" background-color="white"></v-text-field>
													</div>
												</td>
												<td>1 Kg</td>
												<td>24 Kg</td>
												<td>
													<v-tooltip bottom>
														<template v-slot:activator="{ on, attrs }">
															<div class="cursor-pointer" v-bind="attrs" v-on="on">
																<v-icon color="pink">mdi-delete-outline</v-icon>
															</div>
														</template>
														<span>Hapus</span>
													</v-tooltip>
												</td>
											</tr>
										</tbody>
									</template>
								</v-simple-table>
							</v-card>
						</v-col>
					</v-row>
					
					<v-row>
						<v-col cols="12">
							<v-textarea outlined placeholder="Catatan Pengiriman" color="primary lighten-1" no-resize height="100"></v-textarea>
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="grey darken-1" outlined class="text-capitalize" @click="modalHide()">Batal</v-btn>
					<v-btn dark color="primary lighten-1" depressed class="text-capitalize">Simpan</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-row>
</template>

<script>
// import Maps from './Maps';
import { gmapApi } from 'vue2-google-maps';

export default {
	components: {
		// Maps
	},
	data () {
		return {
			dialog: false,
			menu:false,
			markers: [],
			map: null,
			mapCenter: { lat: -7.797068, lng: 110.3571025 },
		}
	},
	props: {
	},
	computed: {
		google() {
			return gmapApi();
		},
	},
	methods: {

		modalShow() {
			this.dialog = true
		},
		modalHide() {
			this.dialog = false
		},
		initMap() {
			this.map = new this.google.maps.Map(document.getElementById('map'), {
				center: this.mapCenter,
				zoom: true,
				maxZoom: 20,
				minZoom: 3,
				mapTypeControl: true,
				fullscreenControl: true,
				zoomControl: true,
			})
		},
		// setMarker(points, label) {
		// 	const markers = new google.maps.Marker({
		// 		position: points,
		// 		map: this.map
		// 	})
		// }
	},
	watch: {
	},
	created() {
	},
	mounted() {
		// this.initMap()
		// this.markers = [
		// {
		// 	location: new this.google.maps.LatLng({ lat: -7.797068, lng: 110.3571025 }),
		// 	weight: 100
		// },
		// {
		// 	location: new this.google.maps.LatLng({ lat: -6.200000, lng: 106.816666 }),
		// 	weight: 50
		// },
		// ];
	}
};
</script>